/**
 * State
 */
const state = {

};

/**
 * Getters
 */
const getters = {
    allFaqs: (getters, rootGetters) => {
        return [...rootGetters.bookingFaqs, ...rootGetters.guaranteeFaqs, ...rootGetters.locationFaqs, ...rootGetters.paymentFaqs, ...rootGetters.repairFaqs, ...rootGetters.termsFaqs, ...rootGetters.currencySymbol];
    },
    bookingFaqs: (getters, rootGetters) => {
        let bookMultiple = {
            category: "booking",
            id: "book-multiple",
            question: "Can I book multiple repairs?",
            answer: "<strong>If all of your devices are out of warranty:</strong> When you get to the repair select step in the booking process, simply tick all the repairs you require. If you want to book repairs for additional devices, click \"Add another device\" on the basket page.<br /><br /><strong>If any of your devices are in warranty:</strong> It is only possible to book a single in warranty device. If you wish to book repairs on additional devices, please make multiple bookings."
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") bookMultiple.answer = "When you get to the repair select step in the booking process, simply tick all the repairs you require. If you want to book repairs for additional devices, click \"Add another device\" on the basket page.";

        let selectRepairTime = {
            category: "booking",
            id: "select-repair-time",
            question: "Is it possible to select a specific time for my repair?",
            answer: "Unfortunately not. You’ll be allocated the earliest appointment available. The time will be confirmed to you via SMS and email at 18:00 on the evening before your repair."
        };
        let manageBooking = {
            category: "booking",
            id: "manage-booking",
            question: "Can I manage my booking?",
            answer: "If you need to change your repair address or appointment date, add an IMEI/serial number for a device or cancel your booking, you can do that <a href='/manage' target='_blank'>here</a>. When prompted, enter your email address and order number, which can be found in your confirmation email."
        };
        let changeDate = {
            category: "booking",
            id: "change-date",
            question: "Can I change the date of my repair?",
            answer: `Yes, you can change the date of your repair on the <a href='/manage' target='_blank'>manage booking</a> page.<br /><br />Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) changeDate.answer = "Yes, you can change the date of your repair on the <a href='/manage' target='_blank'>manage booking</a> page.<br /><br />Please note we require a minimum of 24 hours notice for any changes.";

        let wrongDeviceBooked = {
            category: "booking",
            id: "wrong-device-booked",
            question: "What happens if I've booked the wrong device?",
            answer: `If you book the wrong model and/or colour then your Likewize Repair technician won't have the correct spares to carry out your repair. This will incur a ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee and another appointment will have to be booked. Please contact us as soon as possible to let us know.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) wrongDeviceBooked.answer = "If you book the wrong model and/or colour then your Likewize Repair technician won't have the correct spares to carry out your repair and another appointment will have to be booked. Please contact us as soon as possible to let us know.";

        let deviceHeavilyDamaged = {
            category: "booking",
            id: "device-heavily-damaged",
            question: "What happens if my device is heavily damaged?",
            answer: `Contact the Likewize Repair team before you book if you think your device is heavily damaged. Failure to do so may result in your repair not being carried out and a ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} charge being applied.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) deviceHeavilyDamaged.answer = "Contact the Likewize Repair team before you book if you think your device is heavily damaged. Failure to do so may result in your repair not being carried out.";

        let cancelRepair = {
            category: "booking",
            id: "cancel-repair",
            question: "Can I cancel my repair?",
            answer: `Yes, you can cancel your repair on the <a href='/manage' target='_blank'>manage booking</a> page.<br /><br />Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) cancelRepair.answer = "Yes, you can cancel your repair on the <a href='/manage' target='_blank'>manage booking</a> page.<br /><br />Please note we require a minimum of 24 hours notice for any changes.";

        let devicesNotRepaired = {
            category: "booking",
            id: "devices-not-repaired",
            question: "Are there any devices that you do not fix?",
            answer: "We strive to repair many of the most popular models, however there are unfortunately some we are unable to service. To see if we can repair your device, enter your postcode on the <a href='/' target='_blank'>homepage</a> and follow the steps to select from the list of available models."
        };

        return [bookMultiple, selectRepairTime, manageBooking, changeDate, wrongDeviceBooked, deviceHeavilyDamaged, cancelRepair, devicesNotRepaired];
    },
    guaranteeFaqs(getters, rootGetters) {
        let wefixGuaranteeLength = {
            category: "guarantee",
            id: "wefix-guarantee-length",
            question: "How long is the Likewize Repair guarantee?",
            answer: "All Likewize Repair repairs are guaranteed for twelve months from the date they are undertaken. The guarantee is 100% no-quibble."
        };
        let guaranteeCover = {
            category: "guarantee",
            id: "guarantee-cover",
            question: "What does the guarantee cover?",
            answer: "It covers the specific fault that Likewize Repair repaired."
        };
        let guaranteeClaim = {
            category: "guarantee",
            id: "guarantee-claim",
            question: "How do I claim under the guarantee?",
            answer: "Email your name, address and details of your device to <a href='mailto:contact@wefix.co.uk'>contact@wefix.co.uk</a> and we'll get things sorted."
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") guaranteeClaim.answer = "Email your name, address and details of your device to <a href='mailto:contact@wefix.com.au'>contact@wefix.com.au</a> and we'll get things sorted.";

        return [wefixGuaranteeLength, guaranteeCover, guaranteeClaim];
    },
    locationFaqs(getters, rootGetters) {
        let workshopNearMe = {
            category: "location",
            id: "workshop-near-me",
            question: "Is there a Likewize Repair mobile workshop where I am?",
            answer: "There are Likewize Repair mobile workshops all over the UK*. Use the postcode checker on the <a href='/' target='_blank'>homepage</a> to find out if there's one near you.<br /><br /><small class='text-muted'>* Service available across the United Kingdom subject to postcode</small>"
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") workshopNearMe.answer = "There are Likewize Repair mobile workshops all over Sydney and Melbourne*. Use the address checker on the <a href='/' target='_blank'>homepage</a> to find out if there's one near you.<br /><br /><small class='text-muted'>* Service available across Sydney and Melbourne, subject to address</small>";

        let wefixAddress = {
            category: "location",
            id: "wefix-address",
            question: "Where does Likewize Repair live?",
            answer: "The Likewize Repair central office is in Maldon in Essex. The address is Unit 8 Wyke Hill Business Park, Wyke Hill, Maldon, Essex, CM9 6UZ"
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") wefixAddress.answer = "The Likewize Repair central office is in Melbourne. The address is Level 9, South Tower, 485 La Trobe Street, Melbourne, Victoria, Australia 3000";

        return [workshopNearMe, wefixAddress];
    },
    paymentFaqs(getters, rootGetters) {
        let repairCost = {
            category: "payments",
            id: "repair-cost",
            question: "How much will my repair cost?",
            answer: "The cost of your repair will depend on your device and what repairs are required. To find out how much your repair will cost, enter your postcode on the <a href='/' target='_blank'>homepage</a> and follow the steps to select your device and all required repairs. You'll see the total cost on the basket page."
        };
        let paymentMethods = {
            category: "payments",
            id: "payment-methods",
            question: "What payment methods do you accept?",
            answer: "We accept all major debit and credit cards, as well as Klarna and PayPal."
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") paymentMethods.answer = "We accept all major debit and credit cards, as well as PayPal.";

        let spreadCost = {
            category: "payments",
            id: "spread-cost",
            question: "Can I spread the cost of my repair?",
            answer: "If your repair qualifies for Klarna payment, you can choose to either pay 30 days after the repair or spread the cost over 3 interest-free instalments.<br /><br />You can find out more about Klarna payments <a href='/klarna' target='_blank'>here</a>."
        };
        let incorrectMissedCharge = {
            category: "payments",
            id: "incorrect-missed-charge",
            question: "Is there a charge if I book the wrong device or miss my appointment?",
            answer: `If you've booked the wrong device or are not available when the technician arrives to your appointment, your appointment will be cancelled and you will incur a ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation charge.<br /><br /><strong>If you've booked the wrong device and/or colour:</strong> Contact us to arrange a new booking.<br /><br /><strong>If you need to change your appointment date:</strong> You can manage your booking <a href='/manage' target='_blank'>here</a>.<br /><br />Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) incorrectMissedCharge.answer = `If you've booked the wrong device or are not available when the technician arrives to your appointment, your appointment will be cancelled.<br /><br /><strong>If you've booked the wrong device and/or colour:</strong> Contact us to arrange a new booking.<br /><br /><strong>If you need to change your appointment date:</strong> You can manage your booking <a href='/manage' target='_blank'>here</a>.<br /><br />Please note we require a minimum of 24 hours notice for any changes.`;

        let multiplePayments = {
            category: "payments",
            id: "multiple-payments",
            question: "My payment has gone through multiple times",
            answer: "If your payment has gone through more than once, please contact us and we'll get any repeat payments refunded for you."
        };

        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") {
            return [repairCost, paymentMethods, incorrectMissedCharge, multiplePayments];
        } else {
            return [repairCost, paymentMethods, spreadCost, incorrectMissedCharge, multiplePayments];
        }
    },
    popularFaqs(getters, rootGetters) {
        let repairCost = {
            category: "popular",
            id: "repair-cost",
            question: "How much will my repair cost?",
            answer: "The cost of your repair will depend on your device and what repairs are required. To find out how much your repair will cost, enter your postcode on the <a href='/' target='_blank'>homepage</a> and follow the steps to select your device and all required repairs. You'll see the total cost on the basket page."
        };
        let changeAddress = {
            category: "popular",
            id: "change-address",
            question: "I need to change my repair address",
            answer: `You can make changes to your booking, along with the repair address <a href='/manage' target='_blank'>here</a>.<br /><br />Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) changeAddress.answer = "You can make changes to your booking, along with the repair address <a href='/manage' target='_blank'>here</a>.<br /><br />Please note we require a minimum of 24 hours notice for any changes.";

        let cantMakeTimeslot = {
            category: "popular",
            id: "cant-make-timeslot",
            question: "I can't make my timeslot",
            answer: `If you need to change your repair date, you can do that on the <a href='/manage' target='_blank'>manage booking</a> page. If you've received your timeslot email or SMS and are unable to make that time, please contact us to reschedule your appointment.<br /><br />Please note we require a minimum of 24 hours notice for any changes. Giving less than 24 hours notice will incur the ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} cancellation fee.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) cantMakeTimeslot.answer = "If you need to change your repair date, you can do that on the <a href='/manage' target='_blank'>manage booking</a> page. If you've received your timeslot email or SMS and are unable to make that time, please contact us to reschedule your appointment.<br /><br />Please note we require a minimum of 24 hours notice for any changes.";

        let multiplePayments = {
            category: "popular",
            id: "multiple-payents",
            question: "My payment has gone through multiple times",
            answer: "If your payment has gone through more than once, please contact us and we'll get any repeat payments refunded for you."
        };

        return [repairCost, changeAddress, cantMakeTimeslot, multiplePayments];
    },
    repairFaqs(getters, rootGetters) {
        let arrivalTime = {
            category: "repair",
            id: "arrival-time",
            question: "When will you arrive?",
            answer: "The time will be confirmed via SMS and email at 18:00 on the evening before your repair. You'll receive a weblink allowing you to track your technician's whereabouts, which should help you get on with your day."
        };
        let repairDuration = {
            category: "repair",
            id: "repair-duration",
            question: "How long does it take?",
            answer: "A standard smartphone screen repair takes approximately thirty minutes. A standard tablet screen repair will take approximately one hour."
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") repairDuration.answer = "A standard smartphone screen repair takes approximately thirty minutes.";

        let oneHourWindow = {
            category: "repair",
            id: "one-hour-window",
            question: "What do you mean by a one-hour window?",
            answer: "Likewize Repair promises to arrive within sixty minutes of the allocated time.<br /><br />You'll receive a weblink allowing you to track your technician's whereabouts, which should help you get on with your day."
        };
        let repairLocation = {
            category: "repair",
            id: "repair-location",
            question: "Where is the repair carried out?",
            answer: "All work is carried out in the Likewize Repair mobile lab-tech workshops, which are Samsung approved."
        };
        if (rootGetters.carrierDetails.formattedWeb === "wefix.com.au") repairLocation.answer = "All work is carried out in the Likewize Repair mobile lab-tech workshops.";

        let technicianComeIntoHome = {
            category: "repair",
            id: "technician-come-into-home",
            question: "Will the Likewize Repair technician need to come into my home or workplace?",
            answer: "No. All work is carried out in the Likewize Repair mobile manufacturer-approved, lab-tech workshops."
        };
        let noParking = {
            category: "repair",
            id: "no-parking",
            question: "What if parking is not available? Does the appointment get cancelled?",
            answer: `Parking is essential which is why we make this clear in all our correspondence. If we arrive and parking is not available, the appointment will unfortunately have to be cancelled and a ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} call-out fee applied.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) noParking.answer = "Parking is essential which is why we make this clear in all our correspondence. If we arrive and parking is not available, the appointment will unfortunately have to be cancelled.";

        let parkingCharges = {
            category: "repair",
            id: "parking-charges",
            question: "Who pays for parking if required?",
            answer: "Any parking charges will be paid for by Likewize Repair."
        };
        let lateForAppointment = {
            category: "repair",
            id: "late-for-appointment",
            question: "I'm going to be late – will the engineer wait?",
            answer: `Your Likewize Repair engineer will wait for up to 15 minutes after which time the appointment will be cancelled and a ${rootGetters.currencySymbol}${rootGetters.carrierDetails.callOutCharge} charge applied.`
        };
        if (!rootGetters.carrierDetails.hasCallOutCharge) lateForAppointment.answer = "Your Likewize Repair engineer will wait for up to 15 minutes after which time the appointment will be cancelled.";

        return [arrivalTime, repairDuration, oneHourWindow, repairLocation, technicianComeIntoHome, noParking, parkingCharges, lateForAppointment];
    },
    termsFaqs() {
        let wefixTerms = {
            category: "terms",
            id: "wefix-terms",
            question: "Can I see the Likewize Repair Terms &amp; Conditions?",
            answer: "You'll find the Likewize Repair Terms & Conditions <a href='/terms'>here</a>."
        };
        let wefixPrivacy = {
            category: "terms",
            id: "wefix-privacy",
            question: "Where can I find the Likewize Repair privacy policy?",
            answer: "You'll find the Likewize Repair privacy policy <a href='/privacy'>here</a>."
        };

        return [wefixTerms, wefixPrivacy];
    }
};

/**
 * Actions
 */
const actions = {

};

/**
 * Mutations
 */
const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}